import React from "react";
import Carousel from "nuka-carousel";
import ReactTimeout from "react-timeout";
import MainSlide from "./slides/main/main.js";
import SolutionsSlide from "./slides/solutions/solutions.js";
import ArticlesSlide from "./slides/articles/articles.js";
import ContactsSlide from "./slides/contacts/contacts.js";
import LicensesSlide from "./slides/licenses/licenses.js";
import LoginSlide from "./slides/login/login.js";
import PartnersSlide from "./slides/partners/partners.js";
import ConnectionSlide from "./slides/connection/connection.js";
import DescriptionSlide from "./slides/description/description.js";
import TariffsSlide from "./slides/tariffs/tariffs.js";
import FeedbackSlide from "./slides/feedback/feedback.js";
import HeatmetersSlide from "./slides/heatmeters/heatmeters.js";

import LeftArrow from "./files/leftArrow.js";
import RightArrow from "./files/rightArrow.js";

import styles from "./carousel.module.css";

class CCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slidesToList: [0, 4, 6, 9],
      slideIndex: 0,
      firstSlide: 0,
      lastSlide: 11,
      interval: null
    };

    this.nextSlideHandler = this.nextSlideHandler.bind(this);
    this.previousSlideHandler = this.previousSlideHandler.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.startInterval = this.startInterval.bind(this);

    this.intervalSlides = this.intervalSlides.bind(this);
  }

  startInterval() {
    this.setState({
      interval: this.props.setInterval(this.intervalSlides, 4000)
    });
  }
  componentDidMount() {
    this.startInterval();
  }
  handleMouseEnter() {
    this.props.clearInterval(this.state.interval);
  }
  handleMouseLeave() {
    this.startInterval();
  }

  intervalSlides() {
    let nextSlideIndex = 0;
    for (var i = 0; i < this.state.slidesToList.length; i++) {
      if (this.state.slideIndex < this.state.slidesToList[i]) {
        nextSlideIndex = this.state.slidesToList[i];
        break;
      }
    }
    //console.log('Slide: ', nextSlideIndex);
    this.setState({slideIndex: nextSlideIndex });
    this.props.currentSlideHandler(nextSlideIndex);
  }

  nextSlideHandler(e) {
    e();

    let nextSlideIndex = this.state.slideIndex + 1;
    if (nextSlideIndex > this.state.lastSlide) {
      nextSlideIndex = this.state.firstSlide;
    }

    this.setState({slideIndex: nextSlideIndex });

    this.props.currentSlideHandler(nextSlideIndex);
  }

  previousSlideHandler(e) {
    e();

    let previousSlideIndex = this.state.slideIndex - 1;
    if (previousSlideIndex < this.state.firstSlide) {
      previousSlideIndex = this.state.lastSlide;
    }

    this.setState({ slideIndex: previousSlideIndex });

    this.props.currentSlideHandler(previousSlideIndex);
  }
  render() {
    return (
      <div
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        className={styles.container}
      >
        <Carousel
          slideIndex={this.state.slideIndex}
          className={styles.carousel}
          style={{ height: "100%" }}
          autoplay={false}
          wrapAround={true}
          transitionMode="fade"
          renderBottomCenterControls={null}
          dragging={false}
          renderCenterLeftControls={({ previousSlide }) => (
            <div
              className={styles.arrow}
              onClick={previousSlideHandler =>
                this.previousSlideHandler(previousSlide)
              }
            >
              <LeftArrow />
            </div>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <div
              className={styles.arrow}
              onClick={nextSlideHandler => this.nextSlideHandler(nextSlide)}
            >
              <RightArrow />
            </div>
          )}
            >
                <MainSlide demoEnter={this.props.demoEnter} />
                <LoginSlide demoEnter={this.props.demoEnter} />
          <SolutionsSlide />
          <DescriptionSlide />
          <HeatmetersSlide />
          <ConnectionSlide />
          <TariffsSlide />
          <ArticlesSlide />
                <FeedbackSlide />
                <LicensesSlide showModal={this.props.showModal} />
          <PartnersSlide />
          <ContactsSlide />
        </Carousel>
      </div>
    );
  }
}

export default ReactTimeout(CCarousel);
